import useBooleanState from "@clave/use-boolean-state";
import React, { useCallback, useEffect, useState } from "react";
import { ApiClient } from "../../ApiClient";
import Spinner from "../../common/Spinner";
import { formatDate } from "../../utils/formatDate";
import formatPrice from "../../utils/formatPrice";
import style from "./Memberships.module.scss";
const apiClient = new ApiClient("/api");
let memberships = null;
async function getMemberships() {
    const r = await apiClient.get("/memberships/list");
    return r.memberships;
}
export function MembershipButton({ id, strings }) {
    const [membership, setMembership] = useState();
    const [monthlyOffer, setMonthlyOffer] = useState(null);
    const [popupOpen, setPopupOpen] = useBooleanState();
    const [busy, setBusy] = useBooleanState();
    const [checked, setChecked] = useBooleanState();
    useEffect(() => {
        (memberships !== null && memberships !== void 0 ? memberships : (memberships = getMemberships()))
            .then((l) => l.find((m) => m.id === parseInt(id)))
            .then(setMembership);
    }, []);
    useEffect(() => {
        if (!(membership === null || membership === void 0 ? void 0 : membership.customerSubscriptionId))
            return;
        apiClient
            .get(`/memberships/monthlyoffers/${membership.id}`)
            .then((r) => r.monthlyOffer)
            .then(setMonthlyOffer);
    }, [membership]);
    const becomeMember = useCallback(async () => {
        setBusy.toTrue();
        try {
            var result = await apiClient.post(`/memberships/becomeMember/${id}`, {});
            window.gtag("event", "Members", {
                membership_id: id,
            });
            setMembership((m) => ({
                ...m,
                customerSubscriptionId: result,
            }));
        }
        finally {
            setChecked.toFalse();
            setPopupOpen.toFalse();
            setBusy.toFalse();
        }
    }, []);
    const cancelMembership = useCallback(async () => {
        setBusy.toTrue();
        try {
            await apiClient.post(`/memberships/cancelMembership/${membership === null || membership === void 0 ? void 0 : membership.customerSubscriptionId}`, {});
            setMembership((m) => ({
                ...m,
                customerSubscriptionId: undefined,
            }));
        }
        finally {
            setChecked.toFalse();
            setPopupOpen.toFalse();
            setBusy.toFalse();
        }
    }, [membership]);
    const cancelMonthlyOffer = useCallback(async () => {
        if (!confirm(strings.monthlyOffer.cancelMonthlyOfferPrompt))
            return;
        setBusy.toTrue();
        try {
            await apiClient.post(`/memberships/cancelMonthlyOffer/${monthlyOffer === null || monthlyOffer === void 0 ? void 0 : monthlyOffer.salesOrderRequestId}`, {});
            setMonthlyOffer((m) => ({
                ...m,
                status: "Cancelled",
            }));
        }
        finally {
            setChecked.toFalse();
            setPopupOpen.toFalse();
            setBusy.toFalse();
        }
    }, [monthlyOffer]);
    if (!membership) {
        return React.createElement(Spinner, null);
    }
    if (membership.customerSubscriptionId) {
        return (React.createElement(React.Fragment, null,
            popupOpen && (React.createElement("div", { className: style.membershipNotificationContainer, onClick: (e) => setPopupOpen(e.target !== e.currentTarget) },
                React.createElement("div", { className: style.membershipNotification },
                    React.createElement("h2", null, membership.name),
                    strings.cancelMembershipPopupText
                        .split("\n")
                        .map((t, i) => (React.createElement("p", { key: i }, t))),
                    React.createElement("div", { className: style.membershipAccept },
                        React.createElement("button", { className: "btn primary", onClick: cancelMembership }, busy ? (React.createElement(Spinner, { size: "mini" })) : (strings.cancelMembership)))))),
            React.createElement("div", { className: style.container },
                React.createElement("button", { className: "button button-ghost", onClick: setPopupOpen.toTrue }, strings.cancelMembership),
                monthlyOffer && (React.createElement("div", { className: style.monthlyOffer },
                    React.createElement("span", { className: style.title }, strings.monthlyOffer.title),
                    React.createElement("div", { className: style.body },
                        React.createElement("div", { className: style.info },
                            React.createElement("b", null, monthlyOffer.description),
                            React.createElement("span", null,
                                strings.monthlyOffer.price,
                                ":",
                                " ",
                                React.createElement("strong", null, formatPrice(monthlyOffer.totalAmount))),
                            monthlyOffer.status == "Active" ? (React.createElement("span", null,
                                strings.monthlyOffer.validTo,
                                ":",
                                " ",
                                React.createElement("strong", null, formatDate(monthlyOffer.validTo)))) : monthlyOffer.status === "Accepted" ? (React.createElement("strong", null, strings.monthlyOffer.statusSendt)) : monthlyOffer.status === "Cancelled" ? (React.createElement("strong", null, strings.monthlyOffer.statusCancelled)) : undefined,
                            monthlyOffer.absoluteUrl && React.createElement("div", { className: style.link },
                                React.createElement("strong", null,
                                    React.createElement("a", { href: monthlyOffer.absoluteUrl }, strings.monthlyOffer.seeMore)))),
                        React.createElement("div", { className: style.image },
                            React.createElement("img", { src: monthlyOffer.imageUrl }))),
                    monthlyOffer.status === "Active" && (React.createElement("div", { className: style.cancelBtn },
                        React.createElement("button", { disabled: busy, className: "button button-tiny button-ghost", onClick: cancelMonthlyOffer }, busy ? (React.createElement(Spinner, { size: "mini" })) : (strings.monthlyOffer.cancelMonthlyOffer)))))))));
    }
    return (React.createElement(React.Fragment, null,
        popupOpen && (React.createElement("div", { className: style.membershipNotificationContainer, onClick: (e) => setPopupOpen(e.target !== e.currentTarget) },
            React.createElement("div", { className: style.membershipNotification },
                React.createElement("h2", null, membership.name),
                strings.becomeMemberPopupText
                    .split("\n")
                    .map((t, i) => (React.createElement("p", { key: i }, t))),
                React.createElement("div", { className: style.membershipAccept },
                    React.createElement("label", null,
                        React.createElement("input", { type: "checkbox", onChange: (e) => setChecked(e.target.checked) }),
                        strings.acceptTerms),
                    React.createElement("button", { disabled: !checked, className: "btn primary", onClick: becomeMember }, busy ? (React.createElement(Spinner, { size: "mini" })) : (strings.becomeMember)))))),
        React.createElement("div", { className: style.container },
            React.createElement("button", { className: "btn primary", onClick: setPopupOpen.toTrue }, busy ? React.createElement(Spinner, { size: "mini" }) : strings.becomeMember))));
}
